import { CssBaseline } from '@mui/material';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import React from 'react';

import { theme } from '../../../packages/common/shared-ui/src/theme';

const ThemeSetup = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <StyledEngineProvider injectFirst />
      {children}
    </ThemeProvider>
  );
};

export default ThemeSetup;
